import { render, staticRenderFns } from "./me.vue?vue&type=template&id=3faa48ed&scoped=true&"
import script from "./me.vue?vue&type=script&lang=ts&"
export * from "./me.vue?vue&type=script&lang=ts&"
import style0 from "./me.vue?vue&type=style&index=0&id=3faa48ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa48ed",
  null
  
)

export default component.exports